import { render, staticRenderFns } from "./menuIcon.vue?vue&type=template&id=0f0080b0&"
import script from "./menuIcon.vue?vue&type=script&lang=js&"
export * from "./menuIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports